import store from "@/store";

/**
 * Directiva v-permission
 * Oculta elementos del DOM si el usuario no tiene el permiso especificado
 *
 * Uso:
 * <button v-permission="'animales.crear'">Crear Animal</button>
 * <div v-permission="['animales.leer', 'lotes.leer']">Contenido</div>
 *
 * Con modificadores:
 * v-permission.disable - Deshabilita en lugar de ocultar
 * v-permission.any - Requiere AL MENOS uno de los permisos (OR)
 * v-permission (sin array) - Requiere TODOS los permisos (AND)
 */
export default {
  mounted(el, binding) {
    checkPermission(el, binding);
  },

  updated(el, binding) {
    checkPermission(el, binding);
  },
};

function checkPermission(el, binding) {
  const { value, modifiers } = binding;
  const hasPermissionGetter = store.getters["userTamboStore/hasPermission"];
  const isGestor = store.getters["userTamboStore/isGestor"];

  // Si es gestor, siempre tiene acceso
  if (isGestor) {
    el.style.display = "";
    el.disabled = false;
    return;
  }

  let hasAccess = false;

  if (Array.isArray(value)) {
    // Si es un array de permisos
    if (modifiers.any) {
      // Requiere AL MENOS uno (OR)
      hasAccess = value.some((permission) => hasPermissionGetter(permission));
    } else {
      // Requiere TODOS (AND) - comportamiento por defecto
      hasAccess = value.every((permission) => hasPermissionGetter(permission));
    }
  } else if (typeof value === "string") {
    // Si es un solo permiso
    hasAccess = hasPermissionGetter(value);
  } else {
    console.warn("v-permission: valor debe ser string o array de strings");
    return;
  }

  if (!hasAccess) {
    if (modifiers.disable) {
      // Deshabilitar en lugar de ocultar
      el.disabled = true;
      el.classList.add("disabled");
      el.title = "No tienes permisos para esta acción";
    } else {
      // Ocultar por defecto
      el.style.display = "none";
    }
  } else {
    el.style.display = "";
    el.disabled = false;
    el.classList.remove("disabled");
  }
}
